import { useTranslation } from 'react-i18next';

import type { Board } from '@/entities/board';
import { Dialog } from '@/shared/ui';

import { CreateBoardForm } from './CreateBoardForm';

/** "New board": a compact dialog instead of a permanently visible form on the workspace page. */
export function CreateBoardDialog({
  workspaceId,
  sectionId,
  onCreated,
  onClose,
}: {
  workspaceId: string;
  sectionId?: string | null | undefined;
  onCreated: (board: Board) => void;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Dialog title={t('boards.createTitle')} size="lg" onClose={onClose}>
      <CreateBoardForm
        workspaceId={workspaceId}
        sectionId={sectionId}
        onCreated={onCreated}
        onCancel={onClose}
      />
    </Dialog>
  );
}
